// General Construction subtrade catalog — used by Vlad's org as the
// model account. Once approved live, these become the GC default.

export const GC_VLAD_ORG_ID = "09db7bbe-2c44-4fd6-a580-abe808a3db4f";

export type PropertyClass = "residential" | "commercial";
export type ProjectType =
  | "renovation"
  | "new_construction"
  | "build_out";

export const PROJECT_TYPES_BY_CLASS: Record<PropertyClass, { value: ProjectType; label: string }[]> = {
  residential: [
    { value: "renovation", label: "Renovation" },
    { value: "new_construction", label: "New Construction" },
  ],
  commercial: [
    { value: "build_out", label: "Build-Out" },
    { value: "new_construction", label: "New Construction" },
    { value: "renovation", label: "Renovation" },
  ],
};

type Key = `${PropertyClass}:${ProjectType}`;

export const SUBTRADES: Record<Key, string[]> = {
  "residential:renovation": [
    "Demo", "Framing", "Drywall", "Flooring", "Painting", "Kitchen", "Bathroom",
    "Plumbing", "Electrical", "HVAC", "Roofing", "Siding", "Windows & Doors",
    "Insulation", "Trim & Millwork", "Tile", "Cabinets & Countertops",
    "Decks/Patios", "Landscaping", "Cleanup",
  ],
  "residential:new_construction": [
    "Site Prep", "Excavation", "Foundation", "Framing", "Roofing", "Siding",
    "Windows & Doors", "Plumbing Rough", "Electrical Rough", "HVAC Rough",
    "Insulation", "Drywall", "Flooring", "Tile", "Paint", "Kitchen", "Bathrooms",
    "Trim", "Cabinets", "Pool", "Driveway", "Landscaping", "Final Cleanup",
  ],
  "residential:build_out": [], // not used
  "commercial:build_out": [
    "Demo", "Metal Framing", "Drywall", "Ceilings (ACT)", "Flooring", "Tile", "Paint",
    "Doors/Frames/Hardware", "Glazing", "Plumbing", "Electrical", "HVAC",
    "Fire Sprinklers", "Fire Alarm", "Data/Low-Voltage", "Millwork",
    "Restrooms", "Kitchen/Break Room", "Signage", "Driveway", "Final Cleanup",
  ],
  "commercial:new_construction": [
    "Site Work", "Excavation", "Foundation", "Structural Steel", "Concrete",
    "Masonry", "Roofing", "Exterior Cladding", "Glazing/Curtain Wall",
    "Plumbing", "Electrical", "HVAC", "Fire Protection", "Elevators",
    "Interior Build-Out", "Finishes", "Tile", "Site Improvements", "Driveway", "Landscaping",
  ],
  "commercial:renovation": [
    "Demo", "Abatement", "Framing", "Drywall", "Ceilings", "Flooring", "Tile", "Paint",
    "Plumbing", "Electrical", "HVAC", "Fire Protection", "Roofing", "Facade",
    "Windows", "Doors/Hardware", "Millwork", "Restrooms", "Driveway", "Cleanup",
  ],
};

export function getSubtrades(cls: PropertyClass, proj: ProjectType): string[] {
  return SUBTRADES[`${cls}:${proj}` as Key] ?? [];
}

export function projectTypeLabel(proj: ProjectType): string {
  return proj === "new_construction"
    ? "New Construction"
    : proj === "build_out"
    ? "Build-Out"
    : "Renovation";
}
